module.exports = __webpack_public_path__ + "static/media/icon_close_small.235bf262.svg";